import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitSobCollectingPeriod = createSelector(
  selectFinancialCockpitState,
  ({ sobCollectingPeriod }) => sobCollectingPeriod
)
